import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UtilService } from '@app/services/util.service';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { APP_ROUTES as ROUTES } from '@app/app.routes';
import { environment } from '@environment';

@Component({
  selector: 'layout-toggle-menu-mobile',
  templateUrl: './toggle-menu-mobile.component.html',
  styleUrls: ['./toggle-menu-mobile.component.scss'],
})
export class ToggleMenuMobileComponent implements OnInit {
  public CONST = CONST;
  public ROUTES = ROUTES;
  public clickEvent: boolean = false;

  @Input() clickMenu: boolean = false;
  @Input() currentRoute: string;

  @Output() closeMenu = new EventEmitter<boolean>();

  constructor(private _utilService: UtilService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.clickEvent = changes['clickMenu'].currentValue;
  }

  public onCloseMenu() {
    this.clickEvent = !this.clickEvent;
    this.closeMenu.emit(this.clickEvent);
  }

  public onOpenPrivacyPolicy() {
    this._utilService.onOpenLink(environment.privacy_policy_url);
  }

  public onOpenTermsAndConditions() {
    this._utilService.onOpenLink(environment.terms_and_conditions_enduser_policy_url);
  }

  public onOpenFAQs() {
    this._utilService.onOpenLink(environment.landing_url);
  }
}
